/**
 * <kamal-header> — sticky-on-scroll shadow + mobile navigation drawer.
 */
class KamalHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-kamal-drawer-toggle]');
    this.drawer = this.querySelector('[data-kamal-drawer]');

    if (this.toggle && this.drawer) {
      this.onToggleClick = this.onToggleClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.toggle.addEventListener('click', this.onToggleClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    if (this.classList.contains('kamal-header--sticky')) {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    // Close the drawer when the viewport grows past the desktop breakpoint.
    this.desktop = window.matchMedia('(min-width: 990px)');
    this.onBreakpoint = () => {
      if (this.desktop.matches) this.close();
    };
    this.desktop.addEventListener('change', this.onBreakpoint);
  }

  disconnectedCallback() {
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    if (this.onDocumentClick) document.removeEventListener('click', this.onDocumentClick);
    if (this.desktop) this.desktop.removeEventListener('change', this.onBreakpoint);
  }

  get isOpen() {
    return this.toggle.getAttribute('aria-expanded') === 'true';
  }

  onToggleClick(event) {
    event.preventDefault();
    this.isOpen ? this.close() : this.open();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.close();
      this.toggle.focus();
    }
  }

  onDocumentClick(event) {
    if (this.isOpen && !this.contains(event.target)) this.close();
  }

  onScroll() {
    this.classList.toggle('kamal-header--scrolled', window.scrollY > 8);
  }

  open() {
    this.drawer.hidden = false;
    this.toggle.setAttribute('aria-expanded', 'true');
    const first = this.drawer.querySelector('a, button');
    if (first) first.focus();
  }

  close() {
    if (!this.toggle || !this.drawer) return;
    this.drawer.hidden = true;
    this.toggle.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('kamal-header')) {
  customElements.define('kamal-header', KamalHeader);
}
